import React, { useState, useEffect } from 'react';

export default function Faq(props) {

    const { title, text, block } = props;
    const [active, setActive] = useState(false);


    return (
        <div className="faq-block__container">
            <div className="faq-block__wrapper">
                <div onClick={() => setActive(!active)} className={active ? "faq-block__title caption-4 faq-block__title--active caption-4" : "faq-block__title caption-4"}><span>{title}</span><div className={active ? "faq-block__controller-container faq-block__controller-container--active" : "faq-block__controller-container"}><div className={active ? "minus" : "plus"}></div></div></div>
                <div className={active ? "rich-text-block faq-block__text-container faq-block__text-container--active" : "rich-text-block faq-block__text-container"} dangerouslySetInnerHTML={{
                    __html: text,
                }}>
                </div>
            </div>
        </div>
    );
}
